module.exports = {
  // https://github.com/laravel-mix/laravel-mix/issues/1942
  content: (function () {
    // 💩💩💩💩💩💩
    // /!\ WARNING, start and stop npm run watch after creating a new file /!\
    // 💩💩💩💩💩💩
    // Don't use fast-glob if config is required from browser
    if (typeof window == 'undefined') {
      return require('fast-glob').sync(
        [
            './css/**/*.css',
            './js/**/*.js',
            '../../**/*.php',
        ],
        { dot: true },
      )
    } else {
      return [
          './css/**/*.css',
          './js/**/*.js',
          '../../**/*.php',
      ]
    }
  })(),

  theme: {
    screens: {
      xs: '475px',
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
      '2xl': '1440px',
    },
    extend: {
      fontFamily: {
        sans: ['Nunito', 'arial', 'sans-serif'],
        serif: ['Roboto Serif', 'serif'],
        dyslexic: ['OpenDyslexic', 'serif'],
      },
      fontSize: {
        // xs: ['0.75rem', { lineHeight: '1rem' }],
        xs: ['0.625rem', { lineHeight: '0.75rem' }], //10px //12px
        sm: ['0.75rem', { lineHeight: '0.875rem' }], //12px //14px
        base: ['0.875rem', { lineHeight: '1.125rem' }], //14px //18px
        lg: ['1rem', { lineHeight: '1.25rem' }], //16px //20px
        xl: ['1.125rem', { lineHeight: '1.375rem' }], //18px //22px
        '2xl': ['1.375rem', { lineHeight: '1.375rem' }], //22px
        '3xl': ['1.625rem', { lineHeight: '1.625rem' }], //26px
        '4xl': ['1.875rem', { lineHeight: '1.875rem' }], //30px
        '5xl': ['2.5rem', { lineHeight: '2.5rem' }], //40px
      },
      colors: {
        transparent: 'transparent',
        current: 'currentColor',
        teal: {
          DEFAULT: '#007D8F',
          50: '#FCFDFE', //td even
          100: '#f0f5f7', //td odd
          200: '#E5F2F4', //th
          300: '#BCDCE1', //border
          800: '#007D8F', //default
          900: '#006775', //dark teal
        },
        red: {
          DEFAULT: '#cc0000',
          50: '#FFFCFC', //td even
          100: '#FDF5F5', //td odd
          200: '#FFE5E2', //box
          300: '#F9E5E5', //box border
          400: '#f5cccc', //danger bg
          700: '#D63232', //alert bg
          800: '#cc0000', //default
          900: '#BD0000', //danger txt
        },
        brown: {
          DEFAULT: '#3C2E2E',
          200: '#EEEDED', //bg panel
          300: '#D5D4D4', //border panel
          400: '#d8d5d5', //info bg
          500: '#916E6E', //thead bg
          600: '#886D6D', //placeholder form
          700: '#7A4848', //text highlight
          900: '#3C2E2E', //text base
        },
        orange: {
          DEFAULT: '#EAA000',
          200: '#FEF4EE', //bg panel
          400: '#fbeccc', //warning bg
          800: '#AA5213',
          900: '#8F6200', //warning txt
        },
        green: {
          DEFAULT: '#00B31F',
          400: '#ccf0d2', //success bg
          900: '#007514', //success txt
        },
      },
      margin: {
        menu: '320px',
        '1/24': '4.166665%',
        '1/12': '8.333333%',
      },
      ringColor: (theme) => ({
        //DEFAULT: theme('colors.teal.200'),
      }),
      spacing: {
        // header: 'var(--header-height)',
      },
      width: (theme) => ({
        menu: '320px',
        '1/2g': `calc(50% - ${theme('spacing.8')})`,
        '1/3g': `calc(33.333333% - ${theme('spacing.8')})`,
        '2/3g': `calc(66.666667% - ${theme('spacing.8')})`,
        '1/4g': `calc(25% - ${theme('spacing.8')})`,
        '2/4g': `calc(50% - ${theme('spacing.8')})`,
        '3/4g': `calc(75% - ${theme('spacing.8')})`,
        '1/5g': `calc(20% - ${theme('spacing.8')})`,
        '2/5g': `calc(40% - ${theme('spacing.8')})`,
        '3/5g': `calc(60% - ${theme('spacing.8')})`,
        '4/5g': `calc(80% - ${theme('spacing.8')})`,
        '1/6g': `calc(16.666667% - ${theme('spacing.8')})`,
        '2/6g': `calc(33.333333% - ${theme('spacing.8')})`,
        '3/6g': `calc(50% - ${theme('spacing.8')})`,
        '4/6g': `calc(66.666667% - ${theme('spacing.8')})`,
        '5/6g': `calc(83.333333% - ${theme('spacing.8')})`,
        '1/12g': `calc(8.333333% - ${theme('spacing.8')})`,
        '2/12g': `calc(16.666667% - ${theme('spacing.8')})`,
        '3/12g': `calc(25% - ${theme('spacing.8')})`,
        '4/12g': `calc(33.333333% - ${theme('spacing.8')})`,
        '5/12g': `calc(41.666667% - ${theme('spacing.8')})`,
        '6/12g': `calc(50% - ${theme('spacing.8')})`,
        '7/12g': `calc(58.333333% - ${theme('spacing.8')})`,
        '8/12g': `calc(66.666667% - ${theme('spacing.8')})`,
        '9/12g': `calc(75% - ${theme('pacing.8')})`,
        '10/12g': `calc(83.333333% - ${theme('spacing.8')})`,
        '11/12g': `calc(91.666667% - ${theme('spacing.8')})`,
      }),
    },
  },

  plugins: [
    require('@tailwindcss/forms'), // https://github.com/tailwindlabs/tailwindcss-forms
  ],
}
